export default {
  MazegameTitle: '走迷宫游戏设置',
  topic: '游戏主题',
  inputTopic: '请输入游戏主题',
  questionSettings: '题目设置',
  questionNumber: '题目',
  options: '选项',
  addOption: '新增选项',
  addQuestion: '新增题目',
  removeQuestion: '移除题目',
  removeOption: '移除选项',
  questionText: '题目',
  inputQuestionText: '请输入题目文字',
  optionSettings: '选项设置 (2-4个选项)',
  optionContent: '选项内容',
  setCorrectAnswer: '设为正确答案',
  clearData: '清空数据',
  saveSettings: '保存设置',
  maxQuestions: '最多只能新增10个题目',
  maxOptions: '最多只能新增4个选项',
  minOptions: '至少需要2个选项',
  questionExists: '该题目已存在',
  settingsSaved: '设置已保存',
  pleaseCompleteSettings: '请完成所有必填项目',

  // 游戏画面
  pauseButton: '暂停',
  resumeButton: '继续',
  exitButton: '离开',
  restartButton: '重新开始',
  progress: '进度',
  question: '题目',
  totalQuestions: '总题数',
  gamePaused: '活动暂停',

  // 反馈讯息
  correctAnswerMsg: '答对了！🎉',
  wrongAnswer: '答案不正确，请再试试！',
  gameCompleted: '恭喜完成所有题目！',
  gameOver: '游戏结束',

  // 结算画面
  finalScore: '最终得分',
  accuracy: '正确率',
  timeSpent: '用时',
  wrongAttempts: '错误次数',

  // 控制说明
  controlHint: '使用方向键移动',
  findCorrectExit: '找到正确答案的出口',

  // 答案参考
  referenceAnswers: '参考答案',
  sendSuccess: '游戏数据已成功推送！',
  sendCooldown: '已按过送出，请等候1分钟才可再操作',

  // 新版 Push 功能
  pushSuccess: '游戏活动已成功推送！',
  pushFailed: '推送失败：{message}',
  tokenRefreshing: '正在刷新授权信息，请稍后再试...',

  // 小屏幕警告
  smallScreenWarning: '本游戏为桌面版界面，建议于电脑平板使用，且最低屏幕宽度需求为 1200px*800px',
  currentRank: '当前排名',
  totalParticipants: '总参与人次',
};
